import axios from "axios";
import i18n from "i18next";

const baseURL = process.env.REACT_APP_BASE_URL_AMK_TEST;
const nonTokenEndpoints = [
  "api/method/airport_transport.api.bookings.get_services",
  "api/method/airport_transport.api.bookings.get_vehicles",
  "api/method/airport_transport.api.bookings.get_support_link",
  "api/method/airport_transport.api.bookings.get_settings",
];

const Axios = axios.create({ baseURL });
Axios.defaults.baseURL = baseURL;

// Function to get the current language from Cookies or default to 'en'
const getLanguageFromLocalStorage = () => {
  return localStorage.getItem("language") || "en"; // Fallback to 'en' if no language is stored
};

// Set the initial language header dynamically for every request
Axios.interceptors.request.use((req) => {
  const language = getLanguageFromLocalStorage();

  // Dynamically set the 'accept-language' header for each request
  if (!req.headers["accept-language"]) {
    req.headers["accept-language"] = language;
  }
  req.headers["language"] = language;

  // Don't check the token in the login request
  let token = localStorage.getItem("token");
  if (req.url === "login") {
    return req;
  }

  if (req.url === "register") {
    return req;
  }

  // Clean up pagination parameters if necessary
  if (!req?.url.includes("/list")) {
    const updatedParams = { ...req?.params };
    delete updatedParams?.page;
    delete updatedParams?.limit;
    delete updatedParams?.pageNo;
    req.params = updatedParams;
  }

  // Set Authorization header if a token exists
  if (token && !nonTokenEndpoints.includes(req.url)) {
    req.headers.Authorization = `Bearer ${token}`;
  }

  // Handle form data
  if (req.data instanceof FormData) {
    req.headers["Content-Type"] = "multipart/form-data";
  }

  return req;
});

// Response interceptor to handle errors
Axios.interceptors.response.use(
  (res) => {
    return res;
  },
  (err) => {
    if (err?.response?.status === 401 || err?.response?.status === 403) {
      // Handle session expiry
    }
    return Promise.reject(err);
  }
);

// Function to change language and update Axios headers
const handleAxiosLanguageChange = (newLang) => {
  // Update the language in i18n
  i18n.changeLanguage(newLang);
  // Update the language in Cookies
  localStorage.setItem("language", newLang);
};

export default Axios;
export { handleAxiosLanguageChange };
